var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgShape11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1520,
    height: 447,
    viewBox: "0 0 1520 447",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_586_12919",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1520,
    height: 447
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1520 7.42524C1520 3.32439 1515.52 0 1510 0H10C4.47717 0 0 3.3244 0 7.42525V439.575C0 443.676 4.47717 447 10 447H1510C1515.52 447 1520 443.676 1520 439.575V7.42524Z",
    fill: "#1C1C1C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_586_12919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M530.629 453.758C530.629 453.758 283.395 260.773 -58.1174 263.772C-399.656 266.761 115.141 892.195 115.141 892.195C115.131 892.174 86.6127 856.869 86.6127 856.869",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.219 439.301C517.219 439.301 271.995 239.843 -69.9788 245.253C-411.938 250.662 96.019 899.071 96.019 899.071C96.0089 899.049 67.8768 862.445 67.8768 862.445",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.441 424.393C503.441 424.393 260.208 218.441 -82.211 226.273C-424.626 234.107 76.5318 905.467 76.5318 905.467C76.5219 905.446 48.775 867.542 48.775 867.542",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.139 408.813C489.139 408.813 247.883 196.366 -94.9963 206.618C-437.883 216.875 56.5058 911.191 56.5058 911.191C56.4951 911.169 29.1325 871.965 29.1325 871.965",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.774 393.152C474.774 393.152 235.489 174.228 -107.862 186.899C-451.212 199.572 36.4138 916.854 36.4138 916.854C36.4032 916.832 9.42226 876.328 9.42226 876.328",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.326 377.415C460.326 377.415 222.992 151.991 -120.849 167.081C-464.7 182.175 16.2133 922.423 16.2133 922.423C16.2027 922.401 -10.3977 880.597 -10.3977 880.597",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.836 361.586C445.836 361.586 210.441 129.661 -133.927 147.175C-478.295 164.69 -4.06507 927.911 -4.06507 927.911C-4.07565 927.889 -30.2972 884.783 -30.2972 884.783",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.294 345.693C431.294 345.693 197.825 107.263 -147.057 127.214C-491.936 147.144 -24.3828 933.351 -24.3828 933.351C-24.3939 933.327 -50.239 888.919 -50.239 888.919",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9574 117.182C46.9574 117.182 457.491 236.481 562.277 521.667C667.062 806.831 -571.299 658.264 -571.299 658.264L-501.532 666.201",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8695 103.517C27.8695 103.517 431.235 225.641 538.547 509.604C645.864 793.566 -567.274 634.882 -567.274 634.882L-498.936 643.392",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6313 87.5382C8.6313 87.5382 404.828 212.485 514.657 495.224C624.492 777.962 -563.392 609.182 -563.392 609.182L-496.484 618.264",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.7937 71.3978C-10.7937 71.3978 378.23 199.166 490.58 480.7C602.935 762.233 -559.7 583.343 -559.7 583.343L-494.222 592.999",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30.3771 55.1002C-30.3771 55.1002 351.463 185.667 466.325 465.996C581.183 746.303 -556.193 557.332 -556.193 557.332L-492.145 567.558",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.141 38.7253C-50.141 38.7253 324.522 172.108 441.879 451.212C559.241 730.314 -552.884 531.245 -552.884 531.245L-490.266 542.043",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-70.681 22.794C-70.681 22.794 296.802 158.991 416.645 436.869C536.493 714.744 -550.395 505.606 -550.395 505.606L-489.208 516.974",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-91.5177 6.9167C-91.5177 6.9167 268.781 145.925 391.101 422.576C513.435 699.245 -548.189 480.042 -548.189 480.042L-488.432 491.981",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-113.643 -8.00423C-113.643 -8.00423 239.46 133.794 364.265 409.257C489.065 684.699 -547.292 455.438 -547.292 455.438L-488.966 467.946",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-136.755 -22.214C-136.755 -22.214 209.157 122.391 336.418 396.627C463.683 670.861 -547.414 431.529 -547.414 431.529L-490.518 444.609",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-160.809 -35.7467C-160.809 -35.7467 177.909 111.663 307.613 384.671C437.322 657.677 -548.503 408.302 -548.503 408.302L-493.037 421.951",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-185.711 -48.6433C-185.711 -48.6433 145.808 101.569 277.943 373.348C410.092 645.146 -550.489 385.721 -550.489 385.721L-496.452 399.938",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-210.728 -60.7858C-210.728 -60.7858 113.577 92.2058 248.148 362.796C382.713 633.365 -552.576 363.932 -552.576 363.932L-499.971 378.718",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-235.772 -72.2537C-235.772 -72.2537 81.324 83.5352 218.296 352.896C355.273 622.255 -554.741 342.782 -554.741 342.782L-503.568 358.135",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-259.107 -82.683C-259.107 -82.683 50.7712 75.9013 190.131 344.031C329.493 612.161 -555.231 322.675 -555.231 322.675L-505.489 338.596",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-280.95 -92.1754C-280.95 -92.1754 21.6987 69.1813 163.438 336.101C305.177 603.02 -554.285 303.516 -554.285 303.516L-505.975 320.004",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-301.4 -100.838C-301.4 -100.838 -5.97891 63.3081 138.109 328.997C282.195 594.686 -551.966 285.185 -551.966 285.185L-505.089 302.241",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-320.56 -108.75C-320.56 -108.75 -32.3748 58.1823 114.049 322.66C260.471 587.138 -548.384 267.65 -548.384 267.65C-548.395 267.653 -502.938 285.272 -502.938 285.272",
    stroke: "#F9F9F9",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShape11);
export default __webpack_public_path__ + "static/media/bg-shape-11.94e0864fbe3965f26db9c9c91e630da3.svg";
export { ForwardRef as ReactComponent };